export default "__VITE_ASSET__DxZzlhdq__"